import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { OrderModel } from "src/app/models/order.model";
import { IPayment } from "src/app/models/payment.model";
import { MathService } from "src/app/services/math/math.service";
import { PaymentService } from "src/app/services/payment/payment.service";
import { ProductService } from "src/app/services/product/product.service";

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "cash-in",
  templateUrl: "cash-in.component.html",
  styleUrls: ["./cash-in.component.scss"]
})
export class CashInComponent implements OnInit {
  _payment:IPayment;

  form: UntypedFormGroup;

  _amountToBeReturned = 0;
  _amountReceived = 0;
  _amountReceivedSmallDecimal = 0;
  _amountDue = 0;
  _receivedChanged = false;
  _paymentLinkLoading = false;

  _order:OrderModel = {
    finances:{
      totals:{
        sold:0
      }
    },
    details:{
      currency:'EUR'
    },
    consumer:{
      details:{
        shortDetails:{}
      }
    }
  }

  get order(): OrderModel {
    return this._order;
  }
  @Input('order')
  set order (value:OrderModel){
    this._order = value;
    this._amountDue = this.getAmountDue(value);
    this.setAmountDueAndReceived();
    console.log(value);
  }
  @Input('payment')
  set payment (value:IPayment){
    this._payment = value;
    this.form.patchValue(this._payment);
    this.setAmountDueAndReceived();
    if(value.key){
      this.form.disable();
    }
  }

  @Input()
  public onValidate = (payment:IPayment) => {}
  @Input()
  public onDelete = (payment:IPayment) => {}

  @Output() paymentValidated = new EventEmitter<IPayment>();
  @Output() paymentDeleted = new EventEmitter<IPayment>();

  constructor(public mathService:MathService, private productService:ProductService, public formBuilder: UntypedFormBuilder, private paymentService:PaymentService) {
    this.form = this.formBuilder.group({
        mode: ['', Validators.compose([Validators.required])],
    });

  }

  ngOnInit() {}

  getAmountDue(value:OrderModel):number{
    return (value.finances.totals.sold - value.finances.totals.paid);
  }

  setAmountDueAndReceived(){
    if(this._payment && this._payment.key){
      this._amountReceived = this._payment.debitedFunds.amount;
    }
    else if(this._order){
      this._amountReceived = this.getAmountDue(this._order);
    }
    if(this._order){
      this._amountReceivedSmallDecimal = this.mathService.convertAmountToSmallestCurrencyDecimal(this._amountReceived,this._order.details.currency);
    }
  }

  onClick(value){
    let valueStr = '';
    let receivedStr = this._amountReceivedSmallDecimal.toString();
    if(this._receivedChanged){
      receivedStr += value.toString();
    }
    else{
      receivedStr = value.toString();
    }
    this._receivedChanged = true;
    this._amountReceivedSmallDecimal = parseFloat(receivedStr);
    this._amountReceived = this.mathService.convertAmountToIntCurrency(this._amountReceivedSmallDecimal,this._order.details.currency);
    this._amountDue = this._order.finances.totals.sold - this._order.finances.totals.paid - this._amountReceived;
    if(!this._payment.key){
      this.updateAmountToBeReturned();
    }
  }

  onErase(){
    let valueStr = '';
    let receivedStr = this._amountReceivedSmallDecimal.toString().slice(0, -1);
    if(receivedStr.length == 0){
      this._amountReceivedSmallDecimal = 0;
    }
    else{
      this._amountReceivedSmallDecimal = parseFloat(receivedStr);
    }
    this._amountReceived = this.mathService.convertAmountToIntCurrency(this._amountReceivedSmallDecimal,this._order.details.currency);
    this._receivedChanged = true;
    this.updateAmountToBeReturned();
  }

  onClickValidate(){
    const item = this.form.getRawValue();
    const amount = this._amountDue<0 ? (this._amountReceived+this._amountDue): this._amountReceived;
    this._payment = this.createPayment(this._order,item.mode,amount);
    console.log(this._payment);
    this.onValidate(this._payment);
    this.paymentValidated.emit(this._payment);
  } 
  onClickDelete(){
    this.onDelete(this._payment);
    this.paymentDeleted.emit(this._payment);
  }

  setToAmountDue(){
    this._amountReceived = this._amountDue;
  }

  updateAmountToBeReturned(){
    const _amountToBeReturned = this._amountReceived - this._amountDue;
    this._amountToBeReturned = _amountToBeReturned> 0?_amountToBeReturned:null;
  }

  createPayment(order:OrderModel, mode:string, amount:number):IPayment{
    const payment:IPayment= {
      creationDate:new Date().toISOString(),
      fromUserKey:order.consumer.key,
      toUserKey:order.tournee.producer.key,
      orderKey:order.key,
      tourneeKey:order.tournee.key,
      mode:mode,
      status:'paid',
      debitedFunds: {
        amount:amount,
        currency:order.details.currency
      }
    }
    return payment;
  }

  async requestPayment(){
    this._payment = {
      debitedFunds:{
        currency: this._order.details.currency,
        amount: this._order.finances.totals.sold
      },
      cardType: 'CB_VISA_MASTERCARD'
    }
    if(this._order.market){
      this._payment.marketKey = this._order.market.key;
    }
    else{
      this._payment.tourneeKey = this._order.tournee.key;
    }
    this._paymentLinkLoading = true;
    await this.paymentService.sendPaymentRequestByEmail(this._payment,this._order,this._order.tournee,'web');
    this._paymentLinkLoading = false;
    this.onValidate(this._payment);
    this.paymentValidated.emit(this._payment);
  }
}
